import React, { useState, useEffect, Fragment } from 'react';
// import io from 'socket.io-client';
import axios from 'axios';
import client from '@/lib/feathers';
import styles from './index.module.scss';

// style={{backgroundColor:bgColor}}
const BAButton = (props) => {
  //  console.log("props.item",props.item)
  let color = 'gray';
  if (
    (props.item && props.item.value === '開啟') ||
    (props.item && typeof props.item.value === 'number' && props.item.value > 0)
  )
    color = 'green';
  useEffect(() => {
    // socket = io('http://localhost:3030/');
    // socket.on('hello',data=>{
    //   console.log('==hello',data)
    //   socket.emit('msg','message','test')
    // })
    // client.reAuthenticate().then((data) => {
    //   console.log('==mbb relogin ok', data.user.email);
    // }).catch(err => {
    //   console.log('==mbb relogin fail');
    //   // history.push('/user/login');
    // })
  }, []);

  function getTextUI(item) {
    console.log(item);
    if (item && item.tableText) {
      const arr = item.tableText.split('\n').map((x) => <div>{x}</div>); // .join(<br />)
      return arr;
    } else {
      return <Fragment>無文字</Fragment>;
    }
  }
  return (
    <div
      className={props.sync === 1 ? styles.BAButton : styles.BAButtonShow}
      style={{ backgroundColor: color }}
      onClick={() => {
        if (props.sync === 1) {
          const value = props.item.value == '關閉' ? '開啟' : '關閉';
          let newObj = { ...props.item, value: value };
          console.log('newObj', newObj);
          axios('/ezcon/api/ba/frontSetstate', {
            method: 'POST',
            headers: { authorization: window.localStorage['feathers-jwt'] },
            data: newObj,
          })
            .then((res) => {
              console.log('==Setstate OK', res);
            })
            .catch((error) => {
              console.error('==Setstate Error', error);
            });
        }
      }}
    >
      <div className={styles.ItemText}>{getTextUI(props.item)}</div>
    </div>
  );
};

export default BAButton;
